import Util from '../Util';

function getStatusCodeDesc(isValid, statusCode, expectedStatusCode) {
  if (isValid) {
    return statusCode + ' (valid response)';
  }
  if (statusCode === -1) {
    return statusCode + ' (http error or timed out)';
  }
  return statusCode + ' (expect ' + expectedStatusCode + ')';
}

class AppInfo {
  constructor(obj = {}) {
    this.id = obj.id;
    this.name = obj.name;
    this.hostname = obj.hostname;
    this.insideContainer = obj.insideContainer;
    this.expectedStatusCode = obj.expectedStatusCode;
    this.checkURL = obj.checkURL;
    this.checkURLRequestTimeoutSeconds = obj.checkURLRequestTimeoutSeconds;
    this.checkURLRequestMethod = obj.checkURLRequestMethod;
    this.checkURLRequestBody = obj.checkURLRequestBody;
    this.description = obj.description;
    this.checkStatusCode = obj.checkStatusCode;
    this.checkResult = obj.checkResult;
    this.checkDate = obj.checkDate;
    this.checkLocalDateTime = Util.localDateTimeString(obj.checkDate);
    this.checkXAgo = 'unknown';
    if (obj.checkDate) {
      this.checkXAgo = Util.xUnitsOfTimeAgo(obj.checkDate);
    }
    this.isValidCheckStatusCode = this.checkStatusCode === this.expectedStatusCode;
    this.checkStatusCodeDesc = getStatusCodeDesc(
      this.isValidCheckStatusCode,
      this.checkStatusCode,
      this.expectedStatusCode
    );

    this.prevCheckStatusCode = obj.prevCheckStatusCode;
    this.prevCheckResult = obj.prevCheckResult;
    this.prevCheckDate = obj.prevCheckDate;

    this.prevCheckLocalDateTime = Util.localDateTimeString(obj.prevCheckDate);
    this.prevCheckXAgo = 'unknown';
    if (obj.prevCheckDate) {
      this.prevCheckXAgo = Util.xUnitsOfTimeAgo(obj.prevCheckDate);
    }
    this.isValidPrevCheckStatusCode = this.prevCheckStatusCode === this.expectedStatusCode;
    this.prevCheckStatusCodeDesc = getStatusCodeDesc(
      this.isValidPrevCheckStatusCode,
      this.prevCheckStatusCode,
      this.expectedStatusCode
    );

    // report as service down if two checks failed
    this.isOperational =
      this.isValidCheckStatusCode ||
      (!this.isValidCheckStatusCode && this.isValidPrevCheckStatusCode);

    this.isDisabled = obj.isDisabled;
  }

  toPlainObject() {
    let obj = {};
    let keys = Object.keys(this);
    for (let k of keys) {
      switch (k) {
        // don't include these keys
        case 'checkLocalDateTime':
        case 'checkXAgo':
        case 'checkStatusCodeDesc':
        case 'isValidCheckStatusCode':
        case 'prevCheckLocalDateTime':
        case 'prevCheckXAgo':
        case 'prevCheckStatusCodeDesc':
        case 'isValidPrevCheckStatusCode':
        case 'isOperational':
          break;
        default:
          obj[k] = this[k];
      }
    }
    return obj;
  }
}

export default AppInfo;



// WEBPACK FOOTER //
// ./src/model/AppInfo.js